import React from "react";
import { GraduationCap, HeartHandshake, Sparkles } from "lucide-react";
import { values } from "../mock";
import Reveal from "./Reveal";

const iconMap = {
  education: GraduationCap,
  compassion: HeartHandshake,
  empowerment: Sparkles,
};
const colorMap = { blue: "#187EE4", orange: "#FF6C10", red: "#FF1228" };

const Values = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="text-center mb-12">
            <p className="font-display tracking-widest uppercase text-sm" style={{ color: "#FF6C10" }}>
              What we stand for
            </p>
            <h2 className="mt-2 font-display text-3xl md:text-5xl" style={{ color: "#187EE4" }}>
              Our Core Values
            </h2>
          </div>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {values.map((val, i) => {
            const Icon = iconMap[val.id];
            const color = colorMap[val.color];
            return (
              <Reveal key={val.id} delay={i * 110}>
                <div className="h-full rounded-3xl p-8 bg-white shadow-md hover:shadow-xl transition-shadow border border-slate-100">
                  <div
                    className="flex items-center justify-center w-14 h-14 rounded-2xl mb-5"
                    style={{ backgroundColor: `${color}18` }}
                  >
                    <Icon className="w-7 h-7" style={{ color }} />
                  </div>
                  <h3 className="font-display text-2xl mb-3" style={{ color }}>
                    {val.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed font-medium">{val.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Values;
